var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"full-page center-content",attrs:{"id":"page-not-found"}},[_c('div',[_c('h1',[_vm._v("Página não encontrada")]),_vm._v(" "),_c('p',[_vm._v("Certifique-se de que entrou na página correta")])])])])
}]

export { render, staticRenderFns }